import { resolveChartsSource } from "../../../../services/compliance";

type DistributionBucket = { score?: number; key?: number | string; count?: number; value?: number };
type OverallStats = { yes?: number; partial?: number; no?: number; n_a?: number; total?: number };

export function buildDistributionChartData(params: {
  distribution: DistributionBucket[];
  overallStats?: OverallStats | null;
  isAllStandardsSelected: boolean;
  hasDashboardStandard: boolean;
}) {
  const hasExtended = !!params.overallStats && Number(params.overallStats.total || 0) > 0;
  const source = resolveChartsSource({ hasExtendedData: hasExtended, hasShortData: params.distribution.length > 0 });

  if (!params.isAllStandardsSelected && params.hasDashboardStandard && source === "EXTENDED") {
    const s = params.overallStats || {};
    return [
      { score: 1, count: Number(s.yes || 0) },
      { score: 2, count: Number(s.partial || 0) },
      { score: 3, count: Number(s.no || 0) },
      { score: 4, count: Number(s.n_a || 0) },
    ].filter((r) => r.count > 0);
  }

  return params.distribution
    .map((row) => ({
      score: Number(row.score ?? row.key ?? 0),
      count: Number(row.count ?? row.value ?? 0),
    }))
    .filter((row) => row.score > 0 && row.count > 0)
    .sort((a, b) => a.score - b.score);
}

